module.exports = __webpack_public_path__ + "664ea82e36e23ade921a48bb10562da6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-24.png
// module id = 3184
// module chunks = 0